import { createStructuredSelector, createSelector } from "reselect";
import { workareaSelector } from "features/workarea/selectors";

export const isFetchingSelector = state =>
  state.datatools.getIn(["status", "isFetching"]);
export const isFetchingModalDetailsSelector = state =>
  state.datatools.getIn(["status", "isFetchingModalDetails"]);
export const rangeFilterSelector = state =>
  state.datatools.getIn(["status", "rangeFilter"]);
export const errorFilterSelector = state =>
  state.datatools.getIn(["status", "errorFilter"]);
export const searchFilterSelector = state =>
  state.datatools.getIn(["status", "searchFilter"]);
export const serverSearchFilterSelector = state =>
  state.datatools.getIn(["status", "serverSearchFilter"]);
export const formDataSelector = state =>
  state.datatools.getIn(["status", "formData"]).toJS();
export const modalDataSelector = state =>
  state.datatools.getIn(["status", "modalData"]).toJS();

export const isRecallToDeviceStatusModalOpenSelector = state =>
  state.datatools.getIn(["status", "isRecallToDeviceStatusModalOpen"]);
export const isRecallingToDeviceSelector = state =>
  state.datatools.getIn(["status", "isRecallingToDevice"]);
export const isFetchingDevicesSelector = state =>
  state.datatools.getIn(["status", "isFetchingDevices"]);
export const jsonModalDisplayLevelsSelector = state =>
  state.datatools.getIn(["status", "jsonModalDisplayLevels"]);
export const recallDeviceResponseSelector = state =>
  state.datatools.getIn(["status", "recallDeviceResponse"]).toJS();

export const changeOrderSubmissionIDSelector = state =>
  state.datatools.getIn(["status", "changeOrderSubmissionID"]);

export const processLogSelectedRowIndexSelector = state =>
  state.datatools.getIn(["status", "processLogSelectedRowIndex"]);

export const SubmissionErrorListSelector = state =>
  state.datatools.getIn(["status", "submissionErrors"]).toJS();

export const formJsonModalSearchTextSelector = state =>
  state.datatools.getIn(["status", "formJsonModalSearchText"]);

export const jsonFormModalOpenSelector = state =>
  state.datatools.getIn(["status", "jsonFormModalOpen"]);

export const recallToDeviceModalOpenSelector = state =>
  state.datatools.getIn(["status", "recallToDeviceModalOpen"]);

export const makeTemplateDeviceResponseSelector = state =>
  state.datatools.getIn(["status", "makeTemplateDeviceResponse"]).toJS();
export const makeTemplateToDeviceModalOpenSelector = state =>
  state.datatools.getIn(["status", "makeTemplateToDeviceModalOpen"]);
export const isSendingTemplateToDeviceSelector = state =>
  state.datatools.getIn(["status", "isSendingTemplateToDevice"]);
export const isMakeTemplateToDeviceStatusModalOpenSelector = state =>
  state.datatools.getIn(["status", "isMakeTemplateToDeviceStatusModalOpen"]);

export const formDataJSONSelector = state =>
  state.datatools.getIn(["status", "formDataJSON"]).toJS();
export const isFetchingFormDataJSONSelector = state =>
  state.datatools.getIn(["status", "isFetchingFormDataJSON"]);
export const isDeleteConfirmationOpenSelector = state =>
  state.datatools.getIn(["status", "isDeleteConfirmationOpen"]);

export const changeModalOpenSelector = state =>
  state.datatools.getIn(["status", "changeModalOpen"]);

export const jsonModalOpenSelector = state =>
  state.datatools.getIn(["status", "jsonModalOpen"]);
export const jsonModalDataSelector = state =>
  state.datatools.getIn(["status", "jsonModalData"]).toJS();

export const processLogIndexCheckedArraySelector = state =>
  state.datatools.getIn(["status", "processLogIndexCheckedArray"]).toJS();
export const processLogNewStatusSelector = state =>
  state.datatools.getIn(["status", "processLogNewStatus"]);
export const processLogToggleSelectAllSelector = state =>
  state.datatools.getIn(["status", "processLogToggleSelectAll"]);
export const isUpdatingProcessLogSelector = state =>
  state.datatools.getIn(["status", "isUpdatingProcessLog"]);

export const modalDataDetailsSelector = state =>
  state.datatools.getIn(["status", "modalDataDetails"]).toJS();

export const detailsModalOpenSelector = state =>
  state.datatools.getIn(["status", "detailsModalOpen"]);

export const deviceSelectedSelector = state =>
  state.datatools.getIn(["status", "deviceSelected"]).toJS();

export const devicesSelector = state =>
  state.datatools.getIn(["status", "devices"]).toJS();

export const rowsUpdatingSelector = state =>
  state.datatools.getIn(["status", "rowsUpdating"]).toJS();

export const tabularizedSelector = state =>
  state.datatools.getIn(["status", "tabularized"]).toJS();

// search might be quicker if it was limited to certain fields, but they all seem important
export const formDataSelectorFiltered = createSelector(
  formDataSelector,
  searchFilterSelector,
  (data, searchString) =>
    data.filter(x =>
      [
        x.submitted_dt,
        x.submission_id,
        x.submission_source,
        x.submission_device,
        x.form_name
      ]
        .join(" ")
        .toUpperCase()
        .includes(searchString.toUpperCase())
    )
);

export default createStructuredSelector({
  searchFilter: searchFilterSelector,
  rangeFilter: rangeFilterSelector,
  errorFilter: errorFilterSelector,
  isFetchingModalDetails: isFetchingModalDetailsSelector,
  isFetching: isFetchingSelector,
  formDataFiltered: formDataSelectorFiltered,
  formData: formDataSelector,
  workarea: workareaSelector,
  detailsModalOpen: detailsModalOpenSelector,
  modalData: modalDataSelector,
  modalDataDetails: modalDataDetailsSelector,
  processLogIndexCheckedArray: processLogIndexCheckedArraySelector,
  processLogNewStatus: processLogNewStatusSelector,
  processLogToggleSelectAll: processLogToggleSelectAllSelector,
  jsonModalOpen: jsonModalOpenSelector,
  jsonModalData: jsonModalDataSelector,
  jsonFormModalOpen: jsonFormModalOpenSelector,
  isFetchingFormDataJSON: isFetchingFormDataJSONSelector,
  formDataJSON: formDataJSONSelector,
  changeModalOpen: changeModalOpenSelector,
  changeOrderSubmissionID: changeOrderSubmissionIDSelector,
  recallToDeviceModalOpen: recallToDeviceModalOpenSelector,
  deviceSelected: deviceSelectedSelector,
  devices: devicesSelector,
  isDeleteConfirmationOpen: isDeleteConfirmationOpenSelector,
  serverSearchFilter: serverSearchFilterSelector,
  isRecallingToDevice: isRecallingToDeviceSelector,
  recallDeviceResponse: recallDeviceResponseSelector,
  makeTemplateToDeviceModalOpen: makeTemplateToDeviceModalOpenSelector,
  makeTemplateDeviceResponse: makeTemplateDeviceResponseSelector,
  isSendingTemplateToDevice: isSendingTemplateToDeviceSelector,
  isMakeTemplateToDeviceStatusModalOpen: isMakeTemplateToDeviceStatusModalOpenSelector,
  isRecallToDeviceStatusModalOpen: isRecallToDeviceStatusModalOpenSelector,
  isFetchingDevices: isFetchingDevicesSelector,
  processLogSelectedRowIndex: processLogSelectedRowIndexSelector,
  isUpdatingProcessLog: isUpdatingProcessLogSelector,
  formJsonModalSearchText: formJsonModalSearchTextSelector,
  jsonModalDisplayLevels: jsonModalDisplayLevelsSelector,
  rowsUpdating: rowsUpdatingSelector,
  tabularized: tabularizedSelector,
  submissionErrors: SubmissionErrorListSelector
});
